<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <strong>{{title}}</strong>
        </div>
        @if (!isLoading) {
          <div class="card-body">
            @if (contact.name) {
              <h2 style="margin-bottom : 5px;">{{contact.name}}</h2>
            }
            <mat-chip-listbox aria-label="contact info">
              @if (contact.contactSource) {
                <mat-chip-option>Source : {{contact.contactSource}}</mat-chip-option>
              }
              @if (contact.lastKnownDisposition) {
                <mat-chip-option>Last Disposition :
                {{contact.lastKnownDisposition}}</mat-chip-option>
              }
              @if (contact.freshLeadTag) {
                <mat-chip-option color="primary" selected>{{contact.freshLeadTag}}
                </mat-chip-option>
              }
              @if (contact.needFollowUpTag) {
                <mat-chip-option color="accent" selected>{{contact.needFollowUpTag}}
                </mat-chip-option>
              }
              @if (contact.activeDealStage) {
                <mat-chip-option color="accent" selected>Deal Stage :
                {{contact.activeDealStage}}</mat-chip-option>
              }
            </mat-chip-listbox>
            <div class="comment-box" style="margin-top : 10px;">
              <h3>Latest Interactions</h3>
              <!--begin::Body-->
              <div class="">
                <!--begin::Item-->
                @if (latestInteraction.lastKnownDispositionTime) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-info-circle-fill"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Known Disposition</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastKnownDispositionTime}}</span>
                      </div>
                      <span class="text-muted d-block">{{latestInteraction.lastKnownDisposition |
                      formatEnum}}</span>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastEngagementFromAccount) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-arrow-bar-right"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Engagement By
                          {{latestInteraction.accountName}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastEngagementFromAccount}}</span>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastEngagementFromContact) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-arrow-bar-left"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Engagement By Lead
                          {{latestInteraction.leadName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastEngagementFromContact}}</span>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastCallUserName) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-telephone-fill"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Call By
                          {{latestInteraction.lastCallUserName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastCalledTime}}</span>
                      </div>
                      <span class="text-muted d-block">{{latestInteraction.lastCallDirection}}
                        call&nbsp;@if (latestInteraction.lastCallDuration) {
                        <span>for
                        {{latestInteraction.lastCallDuration}} seconds </span>
                        }@if (latestInteraction.lastCallOutcome) {
                        <span
                          >- Outcome
                        {{latestInteraction.lastCallOutcome}}</span>
                      }</span>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastEmailUserName) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="fa fa-envelope"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Email By
                          {{latestInteraction.lastEmailUserName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastEmailTime}}</span>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastWhatsappUserName) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="fa fa-whatsapp"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Whatsapp By
                          {{latestInteraction.lastWhatsappUserName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastWhatsappTime}}</span>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastVisitTime || latestInteraction.lastVisitOutcome) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-people-fill"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Visit By
                          {{latestInteraction.lastVisitUserName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light ml-auto my-2">{{latestInteraction.lastVisitTime}}</span>
                      </div>
                      <span class="text-muted d-block">@if (latestInteraction.lastVisitOutcome) {
                        <span
                          >Outcome
                        {{latestInteraction.lastVisitOutcome}}</span>
                      }</span>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastNoteAddedTime) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-card-text"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Note By
                          {{latestInteraction.lastNoteUserName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastNoteAddedTime}}</span>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
                <!--begin::Item-->
                @if (latestInteraction.lastTaskDoneTime) {
                  <div class="d-flex flex-row align-items-sm-center"
                    >
                    <!--begin::Symbol-->
                    <div class="symbol symbol-50px me-5">
                      <span class="symbol-label">
                        <i class="bi bi-check2-circle"></i>
                      </span>
                    </div>
                    <!--end::Symbol-->
                    <!--begin::Section-->
                    <div class="d-flex flex-column w-100">
                      <div class="d-flex align-items-center flex-row-fluid justify-content-between">
                        <div class="flex-grow-1 me-2">
                          <a class="text-gray-800 text-hover-primary">Last Task Done By
                          {{latestInteraction.lastTaskDoneUserName | titlecase}}</a>
                        </div>
                        <span
                        class="badge badge-light  ml-auto my-2">{{latestInteraction.lastTaskDoneTime}}</span>
                      </div>
                    </div>
                    <!--end::Section-->
                  </div>
                }
                <!--end::Item-->
              </div>
              <!--end::Body-->
            </div>
            <div class="comment-box">
              <h3>Call Script</h3>
              @if (callScript != null) {
                <div class="message" [innerHTML]="callScript">
                  @if (callScript == null || callScript == '') {
                    <h4>No Calling Script Has Been Set</h4>
                  }
                </div>
              }
            </div>
            <!-- <div class="comment-box">
            <h3>Quick Edit Lead Info</h3>
          </div> -->
        </div>
      }
    </div>
  </div>
</div>
</div>
